import { useAppTranslation } from "@/utils";
import { CheckCircleFilled } from "@payping/icons";
import { Button, Flex, Typography, theme } from "@payping/web-components";
import { FC } from "react";
import PayGetOrderLayout from "../Layout";

interface GoodProps {
  onFinish: () => void;
  description: string;
}
const PayGetOrderCreditScoreGood: FC<GoodProps> = ({ description, onFinish }) => {
  const { t } = useAppTranslation();

  const { token } = theme.useToken();
  return (
    <PayGetOrderLayout showHeaders>
      <Flex vertical className="tw:h-full tw:w-full tw:px-4! tw:pb-4! tw:pt-6!" gap={"middle"} align="center">
        <Flex vertical align="center" gap={"large"} className="tw:my-auto tw:w-full">
          <CheckCircleFilled width={80} className="tw:fill-color-success" />
          <Flex vertical gap={"small"} align="center" className="tw:mt-1! tw:text-center">
            <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
              {t("pay.getOrder.steps.creditScore.goodTitle")}
            </Typography.Title>
            <Typography.Paragraph className="tw:m-0!" type="secondary">
              {t("pay.getOrder.steps.creditScore.goodContent")}
            </Typography.Paragraph>
          </Flex>
          <Flex
            className="tw:w-full tw:p-4!"
            justify="space-between"
            align="center"
            style={{ background: token.colorBgLayout }}
          >
            <Typography.Text>{t("pay.getOrder.steps.creditScore.creditDescription")}</Typography.Text>
            <Typography.Text type="secondary">{description}</Typography.Text>
          </Flex>
        </Flex>
        <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
          <Button
            onClick={() => {
              onFinish();
            }}
            type="primary"
            block
          >
            {t("common.confirmAndContinue")}
          </Button>
        </Flex>
      </Flex>
    </PayGetOrderLayout>
  );
};

export default PayGetOrderCreditScoreGood;
